// import { USER_VIDEO_ID, POLICE_VIDEO_ID } from './video-call-id';
import { canvasToBlob } from './captureScreen';
import { upload } from '@/api/common/upload';

/**
 * 视频通话工具类
 */
class VideoCall {
  public isLogin = false; // 分机是否已登陆

  /**
   * 登陆分机
   * @param username 分机号
   * @param password
   * @param callback 来电话的callback
   */
  public login(
    username: string,
    password: string,
    callback: (phone: string) => void,
    loginCallback: Function,
    userHangUpBack: Function
  ) {
    window.login && window.login(username, password, callback, loginCallback, userHangUpBack);
    this.isLogin = true;
  }
/**
   * 登出分机
   * @param logoutBack 登出callback
   */
  public logout(logoutBack) {
    window.logout && window.logout(logoutBack);
    this.isLogin = false;
  }

  /**
   * 接听电话
   * @param successCallback
   * @param errorCallback
   */
  public answerPhone(successCallback: Function, errorCallback: Function) {
    if (this.isLogin) {
      // 初始化视频通话
      window.anwserPhone(successCallback, errorCallback);
      return;
    }

    console.error('请先登录分机');
  }
  public initVideoTag(selfVideo: string, remoteVideo: string, userName: string, videomsgBack: Function) {
    window.initVideoTag(selfVideo, remoteVideo, userName, videomsgBack);
  }
  public stopRecord() {
    window.stopRecord();
  }
  /**
   * 挂断电话
   * @param successCallback
   * @param errorCallback
   */
  public hangupPhone(successCallback: Function, errorCallback: Function) {
    window.hungupPhone(successCallback, errorCallback);
  }

  /**
   * 共享屏幕
   */
  public shareScreen() {
    window.switchShareScreen('POLICE_VIDEO_ID');
  }

  /**
   * 切换回警察的摄像头
   */
  public switchPoliceCamera() {
    window.switchUserCamera('POLICE_VIDEO_ID');
    console.log('切回自己');
  }

  /**
   * 拨打电话
   * @param phone
   */
  public callPhone(phone: string) {
    window.softPhoneCall(phone);
  }

  /**
   * 拍照
   */
  public videoTakePicture(): HTMLCanvasElement | undefined {
    return window.videoTakePicture();
  }

  /**
   * 拍照，返回照片上传到网络的URL
   */
  public async takePhoto(name = 'screenshot.png'): Promise<string> {
    try {
      const canvas = window.videoTakePicture();
      const blob = await canvasToBlob(canvas);
      return upload(blob, name);
    } catch (error) {
      throw new Error('拍照失败，请重试');
    }
  }

  /**
   * 失败
   */
  private error() {
    console.error('请先登录分机');
  }
}

const videoCall = new VideoCall();

export default videoCall;
